/** @type {string | null} */
let accessToken = null
/** @type {null | (() => Promise<string | null>)} */
let refreshHandler = null
/** @type {Set<(token: string | null) => void>} */
const subscribers = new Set()

export function getAccessTokenState() {
  return accessToken
}

export function setAccessTokenState(token) {
  accessToken = token
}

export function getRefreshHandlerState() {
  return refreshHandler
}

export function setRefreshHandlerState(fn) {
  refreshHandler = fn
}

export function getAuthSubscribers() {
  return subscribers
}
